import {DifficultyLevel} from '@udemy-v2/browse-course';

const getDifficultyLevelsMap = () => {
    // TODO: Explore getting translations from an SSR context for these strings
    return new Map<DifficultyLevel, string>([
        [DifficultyLevel.ALL_LEVELS, 'All Levels'],
        [DifficultyLevel.BEGINNER, 'Beginner'],
        [DifficultyLevel.INTERMEDIATE, 'Intermediate'],
        [DifficultyLevel.EXPERT, 'Expert'],
    ]);
};

export function getDifficultyLevel(level: DifficultyLevel | undefined): string | undefined {
    if (level === undefined) {
        return undefined;
    }
    const difficultyLevelsMap = getDifficultyLevelsMap();
    return difficultyLevelsMap.get(level);
}
